"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const broker_service_1 = require("./broker.service");
const broker_swagger_1 = require("./broker.swagger");
const create_broker_dto_1 = require("./dto/create-broker.dto");
const get_all_broker_dto_1 = require("./dto/get-all-broker.dto");
const update_broker_dto_1 = require("./dto/update-broker.dto");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let BrokerController = class BrokerController {
    constructor(brokerService, scopeService) {
        this.brokerService = brokerService;
        this.scopeService = scopeService;
    }
    /** Add a new broker */
    async createBroker(req, createBrokerDto, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const broker = await this.brokerService.createBroker(createBrokerDto, userId);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, messages_1.successMessage.brokerCreated, broker));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.brokerNotFound, messages_1.errorMessages.brokerCreationFailed, messages_1.errorMessages.unknownError);
        }
    }
    /** Get all brokers */
    async getAllBrokers(getAllBrokersDto, res, req) {
        try {
            const { page, limit, sort, search, searchBy } = getAllBrokersDto;
            const userId = parseInt(req?.headers?.userid);
            const result = await this.brokerService.getAllBrokers(page ?? constants_1.DEFAULT_PAGE, limit ?? constants_1.DEFAULT_LIMIT, sort ?? constants_1.DEFAULT_SORT_FIELD, search, searchBy, userId);
            const mappedResult = {
                data: result.brokers,
                count: result.total,
                totalBrokers: result.totalBrokers,
            };
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerListRetrieved, mappedResult));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.badRequest)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.failedToFetchBrokers || error.message));
        }
    }
    /** Get all brokers with broker name and display name */
    async getBrokerList(query, res, req) {
        try {
            const { page, limit, search, sortBy, sortOrder } = query;
            const userId = parseInt(req?.headers?.userid);
            const brokerList = await this.brokerService.getBrokerList(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sortBy || constants_1.DEFAULT_SORT_FIELD, sortOrder || constants_1.DEFAULT_SORT_ORDER, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerListRetrieved, brokerList));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToFetchBrokers || error.message));
        }
    }
    /** Get a single Broker by ID. */
    async getbrokerDetails(id, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const brokerDetails = await this.brokerService.getBrokerDetails(id, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerDetailsRetrieved, brokerDetails));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.NOT_FOUND)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound || error.message));
        }
    }
    /** Get a single Broker by ID. */
    async getBrokerById(brokerId, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, 'broker', 'view', brokerId);
            if (!viewValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company."));
            }
            const editValidation = await this.scopeService.validateResourceScope(userId, 'broker', 'edit', brokerId);
            const broker = await this.brokerService.getBrokerById(brokerId);
            const response = { ...broker, editable: editValidation };
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerDetails, response));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.badRequest)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.brokerNotFound || error.message));
        }
    }
    /** Modify a broker */
    async modifyBroker(req, brokerId, updateBrokerDto, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'broker', 'edit', brokerId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const broker = await this.brokerService.modifyBroker(brokerId, updateBrokerDto, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerUpdated, broker));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.brokerNotFound, messages_1.errorMessages.failedToUpdateBroker);
        }
    }
    /** Delete an Broker by ID. */
    async deleteBroker(brokerId, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'broker', 'edit', brokerId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const result = await this.brokerService.deleteBroker(brokerId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerDeleted, result));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.brokerNotFound, messages_1.errorMessages.failedToDeleteBroker);
        }
    }
    /** Get contacts of a broker by ID. */
    async getBrokerContacts(brokerId, res) {
        try {
            const contacts = await this.brokerService.getBrokerContacts(brokerId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.brokerContactsRetrieved, contacts));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.brokerContactsNotFound));
            }
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error.message || messages_1.errorMessages.failedToFetchBrokerContacts));
        }
    }
};
exports.BrokerController = BrokerController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, broker_swagger_1.addBrokerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_c = typeof create_broker_dto_1.CreateBrokerDto !== "undefined" && create_broker_dto_1.CreateBrokerDto) === "function" ? _c : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "createBroker", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, broker_swagger_1.getAllBrokersSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof get_all_broker_dto_1.GetAllBrokersDto !== "undefined" && get_all_broker_dto_1.GetAllBrokersDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "getAllBrokers", null);
tslib_1.__decorate([
    (0, common_1.Get)("brokerList"),
    (0, broker_swagger_1.getBrokerListSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "getBrokerList", null);
tslib_1.__decorate([
    (0, common_1.Get)("details/:id"),
    (0, broker_swagger_1.getBrokerDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "getbrokerDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)(":brokerId"),
    (0, broker_swagger_1.getBrokerByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("brokerId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "getBrokerById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":brokerId"),
    (0, broker_swagger_1.updateBrokerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Param)("brokerId")),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number, typeof (_e = typeof update_broker_dto_1.UpdateBrokerDto !== "undefined" && update_broker_dto_1.UpdateBrokerDto) === "function" ? _e : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "modifyBroker", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":brokerId"),
    (0, broker_swagger_1.deleteBrokerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("brokerId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "deleteBroker", null);
tslib_1.__decorate([
    (0, common_1.Get)(":brokerId/contacts"),
    (0, broker_swagger_1.getBrokerContactsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("brokerId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], BrokerController.prototype, "getBrokerContacts", null);
exports.BrokerController = BrokerController = tslib_1.__decorate([
    (0, common_1.Controller)("brokers"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof broker_service_1.BrokerService !== "undefined" && broker_service_1.BrokerService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], BrokerController);
